import { useState } from 'react';
import { Layout, Modal } from 'antd';
import HeaderBar from '../../../Layout/HeaderBar';
import FooterBar from '../../../Layout/FooterBar';

import { useTranslation } from 'react-i18next';
import TableList from '../Table';
import InventoryNav from '../InventoryNav';
import { InventoryContextForType, InventoryType } from '../../../modules/inventory/types';
import EditForm from './EditForm';
import AddForm from './AddForm';
import { Badge } from 'components/ui/badge';

const { Content } = Layout;

interface IHomeViewProps {
  type?: InventoryType.ESP_AQ | InventoryType.MACHINE_ACTIVITY;
  espAq: InventoryContextForType<InventoryType.ESP_AQ>[];
  simcards: InventoryContextForType<InventoryType.SIM_CARDS>[];
  inventoryTagsMap: { [id: string]: { id: string; title: string } };
}

function InventoryEspAqView({ espAq, simcards, inventoryTagsMap, type = InventoryType.ESP_AQ }: IHomeViewProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<string | null>(null);
  const onClose = () => setVisible(null);

  return (
    <>
      <Layout>
        <HeaderBar />
        <Content className="min-w-0 px-4 py-6 md:px-6">
          <div className="mx-auto max-w-[1600px] space-y-5">
            <InventoryNav />
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="flex items-center gap-3">
                  <h1 className="m-0 text-2xl font-semibold tracking-tight">
                    {type === InventoryType.MACHINE_ACTIVITY ? 'Maskinaktivitet' : t('sidenavInventory.dust')}
                  </h1>
                  <Badge variant="secondary">{espAq.length}</Badge>
                </div>
                <p className="mb-0 mt-1 text-sm text-muted-foreground">
                  {t('Søg, find og administrer dit udstyr.')}
                </p>
              </div>
              <AddForm type={type} simcards={simcards} inventoryTagsMap={inventoryTagsMap} />
            </div>
            <TableList
              type={type}
              data={espAq}
              setVisible={setVisible}
              inventoryTagsMap={inventoryTagsMap}
            />
          </div>
        </Content>
        <FooterBar />
      </Layout>
      <Modal
        title={type === InventoryType.MACHINE_ACTIVITY ? "Ret maskinaktivitet" : "Ret ESP_AQ"}
        open={!!visible}
        confirmLoading={false}
        onCancel={onClose}
        footer={[]}
      >
        {visible && (
          <EditForm
            type={type}
            key={visible}
            id={visible}
            onClose={onClose}
            simcards={simcards}
            inventoryTagsMap={inventoryTagsMap}
          />
        )}
      </Modal>
    </>
  );
}

export default InventoryEspAqView;
